import { AxiosError } from 'axios';
import { buildErrorMessage } from './utils';

export class BaseError extends Error {
  readonly status: string; // http status
  readonly code: string;
  readonly url: string;
  readonly axiosError: AxiosError;
  constructor(status: string, code: string, url: string, message: string, axiosError: AxiosError) {
    super(buildErrorMessage({ status, code, url, message }));
    // super(message);
    this.status = status;
    this.code = code;
    this.url = url;
    this.axiosError = axiosError;
  }
}

export class TimeoutError extends BaseError {
  static readonly CODE = 'timeout';
  constructor(status: string, url: string, timeout: number, axiosError: AxiosError) {
    super(
      status,
      TimeoutError.CODE,
      url,
      `The request timed out. The currently set request timeout time is ${timeout}ms`,
      axiosError,
    );
  }
}

export class NetworkError extends BaseError {
  static readonly CODE = 'network_error';
  constructor(status: string, url: string, message: string, axiosError: AxiosError) {
    super(status, NetworkError.CODE, url, message, axiosError);
  }
}

export class TCMError extends BaseError {}

export class UnknowError extends BaseError {
  static readonly CODE = 'unknow';
  constructor(status: string, url: string, message: string, axiosError: AxiosError) {
    super(status, UnknowError.CODE, url, message, axiosError);
  }
}

export class IgnoreError extends BaseError {
  static readonly CODE = 'ignore_error';
}

export class CancelError extends BaseError {
  static readonly CODE = 'canceled';
  constructor(status: string, url: string, message: string, axiosError: AxiosError) {
    super(status, CancelError.CODE, url, message, axiosError);
  }
}

export class AuthorizationError extends BaseError {
  static readonly CODE_401 = 'unauthorized';
  static readonly CODE_403 = 'forbidden';
}
